// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Graduações', true, 'professional')),
  route('create', '/create', Form, professionalMeta('Adicionar Graduações', true, 'professional')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Graduações', true, 'professional'))
]

export default subGroup('/graduations', routes)



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/routes.js